import { useEffect, useState } from 'react';
import type { EditorProps } from './types';

export function GenericJsonEditor({
  config,
  onChange,
}: EditorProps<Record<string, unknown>>) {
  const [text, setText] = useState(() => JSON.stringify(config, null, 2));
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setText(JSON.stringify(config, null, 2));
  }, [config]);

  const handleChange = (value: string) => {
    setText(value);
    try {
      const parsed = JSON.parse(value) as Record<string, unknown>;
      setError(null);
      onChange(parsed);
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Ungültiges JSON');
    }
  };

  return (
    <div className="space-y-2">
      <p className="text-xs text-neutral-500">
        Für diesen Widget-Typ ist noch kein spezialisierter Editor verfügbar. Konfiguration als
        JSON bearbeiten:
      </p>
      <textarea
        value={text}
        onChange={(e) => handleChange(e.target.value)}
        rows={14}
        spellCheck={false}
        className="w-full rounded-lg border border-surface-400 bg-surface-200 px-3 py-2 font-mono text-xs text-neutral-200 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500"
      />
      {error && <p className="text-xs text-red-400">{error}</p>}
    </div>
  );
}
